import { render, staticRenderFns } from "./hairAchievement.vue?vue&type=template&id=5698fde5&"
import script from "./hairAchievement.vue?vue&type=script&lang=js&"
export * from "./hairAchievement.vue?vue&type=script&lang=js&"
import style0 from "./hairAchievement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports